var _rect, _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 41.7712,
    height: 41.7712,
    transform: "translate(0.678833 0.680664)",
    fill: "#D6FDCD"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5644,
    cy: 21.5653,
    r: 20.8856,
    fill: "#BCF1B0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4727 13.8782C17.1682 12.6091 19.28 11.8477 21.5643 11.8477C27.1686 11.8477 31.717 16.3961 31.717 22.0004C31.717 27.6047 27.1686 32.1531 21.5643 32.1531C15.96 32.1531 11.4116 27.6047 11.4116 22.0004C11.4116 20.1627 11.899 18.4368 12.7619 16.9443L21.5643 22.0004",
    stroke: "#299411",
    strokeWidth: 1.30535,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3155 18.9154C15.7609 19.8491 15.4697 20.9157 15.4728 22.0018C15.4728 25.3623 18.2039 28.0934 21.5644 28.0934C24.925 28.0934 27.6561 25.3623 27.6561 22.0018C27.6561 18.6412 24.925 15.9102 21.5644 15.9102C20.6405 15.9102 19.7572 16.1132 18.9755 16.4889",
    stroke: "#299411",
    strokeWidth: 1.30535,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoanIcon);
export default __webpack_public_path__ + "static/media/loanIcon.1eb2aedf5b67a249a26f1cb834c7a8d9.svg";
export { ForwardRef as ReactComponent };